import { useState } from 'react';
import { useMutation } from '@apollo/client';

import { UPDATE_USER_PREFERENCES_MUTATION } from '../../../../queries/authentication/authentication';

import PreferencesFormData from '../interfaces/PreferencesFormData';
import { UpdateUserConsentsInput } from 'graphql.generated';

const useUpdatePreferences = (onSuccess?: () => void) => {
    const [generalError, setGeneralError] = useState(false);

    const [updatePreferencesMutation] = useMutation<
        { updateUserConsents: boolean },
        { input: UpdateUserConsentsInput }
    >(UPDATE_USER_PREFERENCES_MUTATION, {
        onCompleted({ updateUserConsents: response }) {
            if (!response) {
                setGeneralError(true);
                return;
            }
            onSuccess?.();
        },
        onError() {
            setGeneralError(true);
        }
    });

    const updatePreferences = (props: PreferencesFormData) => {
        setGeneralError(false);

        const { consent__insights__24 } = props;

        const input: UpdateUserConsentsInput = {
            consents: [
                {
                    id: 24,
                    agreed: !!consent__insights__24
                }
            ]
        };

        return updatePreferencesMutation({
            variables: {
                input
            }
        });
    };

    return {
        updatePreferences,
        generalError
    };
};

export default useUpdatePreferences;
